var _rect, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 32,
    viewBox: "0 0 46 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 45,
    height: 31,
    rx: 5.5,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.334 21.144h-2.747l-2.06-8.088c-.097-.372-.304-.7-.61-.856a8.764 8.764 0 00-2.517-.856v-.311h4.424c.61 0 1.069.468 1.145 1.011l1.068 5.834 2.745-6.845h2.67l-4.118 10.111zm5.645 0h-2.594l2.136-10.111h2.594l-2.136 10.111zm5.491-7.31c.077-.544.534-.856 1.069-.856a4.713 4.713 0 012.517.466l.458-2.176a6.4 6.4 0 00-2.365-.468c-2.517 0-4.349 1.4-4.349 3.344 0 1.479 1.298 2.255 2.214 2.723.99.466 1.372.778 1.296 1.244 0 .7-.763 1.011-1.525 1.011-.916 0-1.832-.233-2.67-.623l-.458 2.179c.916.388 1.906.544 2.822.544 2.823.077 4.577-1.322 4.577-3.422 0-2.645-3.586-2.8-3.586-3.966zm12.663 7.31l-2.06-10.111h-2.211a1.15 1.15 0 00-1.069.778l-3.813 9.333h2.67l.533-1.477h3.28l.306 1.477h2.364zm-3.89-7.388l.762 3.81H32.87l1.373-3.81z",
    fill: "#172B85"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 45,
    height: 31,
    rx: 5.5,
    stroke: "#F2F4F7"
  })));
}
export default SvgVisa;